import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealApiResponse } from "@zeal/common";
import {
  TUpdateLaborPosterRequestSchema,
  TUpdateLaborPosterResponseSchema,
} from "./updateLaborPoster.schema";

export const updateLaborPoster = (axios: IAxiosInstance) => {
  return async ({
    labor_poster_id,
    ...data
  }: TUpdateLaborPosterRequestSchema): Promise<
    ZealApiResponse<TUpdateLaborPosterResponseSchema>
  > => {
    const response = await axios.noRetry.patch<
      ZealApiResponse<TUpdateLaborPosterResponseSchema>
    >(`/labor-posters/${labor_poster_id}`, data);
    return response.data;
  };
};
